import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload";

import swal from "sweetalert";
const AllApplications = () => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setView] = useState(false);

  const [update, setUpdate] = useState(false);
  const [activeTab, setActiveTab] = useState("Applications");
  const [PageRole] = useState("Applications");

  const [RowData, setRowData] = useState([]);

  const [inputsDocuments, setInputsDocuments] = useState({});

  const url = "api/applicants";

  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const [message, setmessage] = useState("");
  const [applicationTypeOptions, setApplicationType] = useState([
    { name: "Approved" },
    { name: "Rejected" },
  ]);
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const onChangeHandler = (event, name) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
      onClickHandler(event, name, files);
    }
  };
  const onClickHandler = (event, name, selectedFile) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();
      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Upload.post("/api/upload/files", data, {
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200" && res.data.resultCode == "00") {
            setmessage("Uploaded successfully");
            setInputsDocuments((inputs) => ({
              ...inputs,
              [name]: res.data.data,
            }));
          } else {
            setmessage("upload fail");
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };

  const fetchDocuments = async (applicationId) => {
    try {
      Api.get(
        "api/applicationsDocuments/getByApplicationId?applicationId=" +
          applicationId,
      )
        .then(function (response) {
          if (response.status === 200) {
            setInputsDocuments(response.data);
            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["applicationId"]: applicationId,
            }));
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-secondary btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>
        </div>
      </span>
    );
  };
  const setApplicationsdata = async (data) => {
    const rows = data?.applications || [];

    rows.forEach((k) => {
      const Rowdata = {
        id: k.id,
        fullName: k.applicant.fullName,
        applicationType: k.applicationType,
        permitType: k.permitType,
        country: k.applicant.country.name,
        telNo: k.applicant.telNo,
        email: k.applicant.email,
        passportNumber: k.applicant.passportNumber,
        dob: new Date(k.applicant.dob).toLocaleDateString("en-GB"),
        Actions: <MoreActions selecteditem={k} />,
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get("api/applications/getAll?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setApplicationsdata(data);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get("api/applications/getAll?page=" + nextPage + "&size=10")
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setApplicationsdata(data);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
  }, []);

  const handleView = (k) => {
    setInputs(k.applicant);

    setInputsDocuments((inputsDocuments) => ({
      ...inputsDocuments,
      ["applicationId"]: k.id,
    }));

    if (k.id) {
      fetchDocuments(k.id);

      setView(true);
      setOpen(true);
    } else {
      alert("Select a record to view");
    }
  };
  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setView(false);
    setUpdate(false);
  };

  const HandleUpdate = (inputs, url) => {
    useUpdate(url, inputs);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };

  const handleSubmitDocuments = (event) => {
    event.preventDefault();
    if (
      !inputsDocuments.applicationId ||
      inputsDocuments.applicationId == "undefined"
    ) {
      alert("Add or select Applicant first");
      return;
    }
    let body = {
      remarks: inputsDocuments.remarks,
      status: inputsDocuments.status,
      applicationId: inputsDocuments.applicationId,
      stage: "Documents",
    };
    HandleSave(body, "api/applications/approval", "approval");
  };

  const handleDocumentsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsDocuments((documents) => ({ ...documents, [name]: value }));
  };
  const useSave = (url = ``, inputs = {}, menu = ``, config = {}) => {
    let data;
    let headers;
    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { "Content-Type": "application/json", ...config.headers };
    }
    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          if (menu === "Applications") {
            var result = JSON.parse(response.data.data);

            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["applicationId"]: result.id,
            }));
          }

          swal("", "saved", "success");
        } else {
          swal("", response.data.description, "error");
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
      });
  };
  const HandleSave = (inputs, url, menu) => {
    useSave(url, inputs, menu);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate(inputs, url);
    } else {
      HandleSave(inputs, url, "Applications");
    }
  };
  const CallDeleteHook = (id) => {
    useDelete(url + "/delete?id=" + id);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const HandleDelete = (k) => {
    if (k.id) {
      CallDeleteHook(k.id);
    } else {
      alert("Select a record to delete");
    }
  };

  const columns = [
    { label: "Name", field: "fullName", sort: "asc" },
    { label: "Application Type", field: "applicationType", sort: "asc" },
    { label: "Permit Type", field: "permitType", sort: "asc" },
    { label: "Country", field: "country", sort: "asc" },
    { label: "Tel No", field: "telNo", sort: "asc" },
    { label: "Email", field: "email", sort: "asc" },
    { label: "Passport Number", field: "passportNumber", sort: "asc" },
    { label: "DOB", field: "dob", sort: "asc" },
    { label: "Actions", field: "Actions", sort: "asc" },
  ];

  const ActionsBtn = () => (
    <div>
      {useValidateRole(PageRole, "Edit") && (
        <button
          className="btn btn-primary p-2"
          type="button"
          onClick={handleView}
        >
          View
        </button>
      )}
      &nbsp; &nbsp;
      {useValidateRole(PageRole, "Remove") && (
        <button onClick={HandleDelete} className="btn btn-danger p-2">
          Delete
        </button>
      )}
      &nbsp;
      <button
        className="btn btn-warning p-2"
        type="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  );

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item active">All Applications </li>
      </ol>
      <h1 className="page-header mb-3">All Application</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={columns} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="80%" height="80%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <a className="close" onClick={handleCloseModal}>
            &times;
          </a>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                <div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "Applications" ? "active" : ""}`}
                        id="Applications-tab"
                        onClick={() => setActiveTab("Applications")}
                        role="tab"
                        aria-selected={activeTab === "Applications"}
                      >
                        Applications
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "dependants" ? "active" : ""}`}
                        id="dependants-tab"
                        onClick={() => setActiveTab("dependants")}
                        role="tab"
                        aria-selected={activeTab === "dependants"}
                      >
                        Documents
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className={`tab-pane fade ${activeTab === "Applications" ? "show active" : ""}`}
                      id="Applications-tab-pane"
                      role="tabpanel"
                      aria-labelledby="Applications-tab"
                    >
                      <div>
                        <h3>Applications</h3>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td className="font-weight-bold">Name:</td>
                              <td>{inputs.fullName}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Application Type:
                              </td>
                              <td>{inputs.applicationType}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">permit Type:</td>
                              <td>{inputs.permitType}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Passport Number:
                              </td>
                              <td>{inputs.passportNumber}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Tel No:</td>
                              <td>{inputs.telNo}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Email:</td>
                              <td>{inputs.email}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Gender:</td>
                              <td>{inputs.gender?.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Country:</td>
                              <td>{inputs.country?.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Places Of Birth:
                              </td>
                              <td>{inputs.placesOfBirth}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Physical Address:
                              </td>
                              <td>{inputs.physicalAddress}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">DOB:</td>
                              <td>
                                {" "}
                                {new Date(inputs.dob).toLocaleDateString(
                                  "en-GB",
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            "justify-content": "flex-end",
                          }}
                        >
                          <ActionsBtn />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "dependants" ? "show active" : ""}`}
                      id="areas-tab-pane"
                      role="tabpanel"
                      aria-labelledby="dependants-tab"
                    >
                      <form
                        className="form-horizontal"
                        onSubmit={handleSubmitDocuments}
                      >
                        <p>
                          1.Copy of completed application form 25
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.form_25
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          2.Letter explaining purpose of entry address to PS,
                          Ministry of Tourism
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.letter_explaining_purpose
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          3.Copy of valid passport of Applicatin
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.passport_copy
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          4.Copy of current entry permit (renewal only)
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.current_permit
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          5.Copy of Tourism license for the company
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.tourism_license
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          6.Certificate of incorporation of the company
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.certificate_of_incorporation
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          7.Memmorandum & Article of asociation of the company
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.memorandum
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          8.Copy of CR-12
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.cr12
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          9.Company/Applicant PIN
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.pin
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          10.Valid KRA Tax Compliance certificate (for renewals)
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.tax_compliance
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          11.Valid Tourism Fund Clearance(for levy payers and
                          Renewals)
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.tourism_fund_clearance
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          12.Audited account for the company(Renewals only)
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.audited_account
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>

                        <p>
                          13.Proof of capital investment (USD 100,000)
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.proof_of_capital
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          14.Employee profile(Details of all employees in the
                          company - citizens and non-citizens; ID & passport
                          numbers)
                          <a
                            href={
                              process.env.REACT_APP_BASE_URL +
                              "api/upload/files/" +
                              inputsDocuments.employee_profile
                            }
                            target="_blank"
                          >
                            View
                          </a>
                        </p>
                        <p>
                          Comments
                          {inputsDocuments.comments}
                        </p>
                      </form>
                    </div>
                  </div>

                  <br />
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {/* <ActionsBtn /> */}
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AllApplications;
